<template>
    <div class="engineering">
        <el-container>
            <el-main ref="main" class="tabWrap">
                <el-tabs  v-model="activeName" style="width: 100%">
                    <el-tab-pane label="基本信息" name="Tab1">
                        <div v-if="engineerList">
                            <div class="container">
                                <el-form class="dataFormBox" :inline="true" :model="engineerList">
                                    <el-row>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="项目部：">
                                                <el-input v-model="engineerList.deptName" :readonly="true" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="项目名称：">
                                                <el-input v-model="engineerList.projectName" :readonly="true" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="细目名称：">
                                                <el-input v-model="engineerList.subCategoryName" :readonly="true" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="细目号：">
                                                <el-input v-model="engineerList.subCategoryNo" :readonly="true" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="单位：">
                                                <el-input v-model="engineerList.unit" :readonly="true" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="单价：">
                                                <el-input v-model="engineerList.unitPrice" :readonly="true" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="合同数量：">
                                                <el-input v-model="engineerList.contractCount" :readonly="true" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="合同合价：">
                                                <el-input v-model="engineerList.contractSumPrice" :readonly="true" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="核实数量：">
                                                <el-input v-model="engineerList.checkCount" :readonly="true" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="核实合价：">
                                                <el-input v-model="engineerList.checkSumPrice" :readonly="true" clearable></el-input>
                                            </el-form-item>
                                        </el-col>

                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="计量数量：">
                                                <el-input v-model="engineerList.expectCount" :readonly="true" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="计划合价：">
                                                <el-input v-model="engineerList.expectSumPrice" :readonly="true" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="实际完成数量：">
                                                <el-input v-model="engineerList.actFinishCount" :readonly="true" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="实际完成合价：">
                                                <el-input v-model="engineerList.actFinishSumPrice" :readonly="true" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="计划完成数量：">
                                                <el-input v-model="engineerList.expectFinishCount" :readonly="true" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="计划完成合价：">
                                                <el-input v-model="engineerList.expectFinishSumPrice" :readonly="true" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-form>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="预计成本" name="Tab2">
                        <div v-if="engineerList">
                            <el-form class="dataFormBox" :inline="true" :model="engineerList">
                                <el-row>
                                    <el-col :span="6">
                                        <el-form-item label-width="150px" label="预计成本合价：">
                                            <el-input v-model="engineerList.expectCostPrice" :readonly="true" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="6">
                                        <el-form-item label-width="150px" label="预计成本数量：">
                                            <el-input v-model="engineerList.expectCostCount" :readonly="true" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="6">
                                      <el-form-item label-width="150px" label="中标裸税合价：">
                                        <el-input v-model="engineerList.expectBidSumPrice" :readonly="true" clearable></el-input>
                                      </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="6">
                                        <el-form-item label-width="150px" label="预计劳务合价：">
                                            <el-input v-model="engineerList.laborExpectSumPrice" :readonly="true" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="6">
                                        <el-form-item label-width="150px" label="预计材料合价：">
                                            <el-input v-model="engineerList.materialExpectSumPrice" :readonly="true" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="6">
                                        <el-form-item label-width="150px" label="预计机械合价：">
                                            <el-input v-model="engineerList.machineExpectSumPrice" :readonly="true" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="6">
                                        <el-form-item label-width="150px" label="预计其他合价：">
                                            <el-input v-model="engineerList.otherExpectSumPrice" :readonly="true" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                <el-col :span="6">
                                  <el-form-item label-width="150px" label="劳务-中标裸税合价：">
                                    <el-input v-model="engineerList.laborBidSumPrice" :readonly="true" clearable></el-input>
                                  </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                  <el-form-item label-width="150px" label="材料-中标裸税合价：">
                                    <el-input v-model="engineerList.materialBidSumPrice" :readonly="true" clearable></el-input>
                                  </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                  <el-form-item label-width="150px" label="机械-中标裸税合价：">
                                    <el-input v-model="engineerList.machineBidSumPrice" :readonly="true" clearable></el-input>
                                  </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                  <el-form-item label-width="150px" label="其他-中标裸税合价：">
                                    <el-input v-model="engineerList.otherBidSumPrice" :readonly="true" clearable></el-input>
                                  </el-form-item>
                                </el-col>
                              </el-row>
                            </el-form>

                            <div class="container">
                                <delete-module class="deleteModule" :list.sync="engineerList.laborExpectList" :index="1" titleTxt="预计劳务信息"></delete-module>
                                <delete-module class="deleteModule" :list.sync="engineerList.materialExpectList" :index="1" titleTxt="预计材料信息" ></delete-module>
                                <delete-module class="deleteModule" :list.sync="engineerList.machineExpectList" :index="1" titleTxt="预计机械信息"></delete-module>
                                <delete-module class="deleteModule" :list.sync="engineerList.otherExpectList" :index="1" titleTxt="预计其他信息"></delete-module>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="实际成本" name="Tab3">
                        <div v-if="engineerList">
                            <el-table
                                    ref="dataTable"
                                    :data="engineerList.partyActTotalList"
                                    highlight-current-row
                                    size="mini"
                                    height="200px"
                                    border
                            >
                                <el-table-column label="合作单位" prop="partyBName" :show-overflow-tooltip="true"></el-table-column>
                                <el-table-column label="实际成本合价" prop="unitSumPrice" :show-overflow-tooltip="true"></el-table-column>
                                <el-table-column label="实际成本单价" prop="unitPrice" :show-overflow-tooltip="true"></el-table-column>
                                <el-table-column label="中标裸税合价" prop="bidSumPrice" :show-overflow-tooltip="true"></el-table-column>
                            </el-table>
                            <div class="container" style="margin-top: 16px">
                                <div v-for="(partyActItem,partyActIndex) in engineerList.partyActList"
                                     :key="'partyActItem'+ partyActIndex">
                                    <div class="">{{partyActItem.partyBName}}:</div>
                                    <div class="moduleList">
                                        <delete-module class="deleteModule" :list.sync="partyActItem.laborActList"  :index="2" :isShowModifyBtn="true" titleTxt="劳务信息" @refreshData="getFrontDetail"></delete-module>
                                        <delete-module class="deleteModule" :list.sync="partyActItem.materialActList"  :index="2" :isShowModifyBtn="true" titleTxt="材料信息" @refreshData="getFrontDetail"></delete-module>
                                        <delete-module class="deleteModule" :list.sync="partyActItem.machineActList"  :index="2" :isShowModifyBtn="true" titleTxt="机械信息" @refreshData="getFrontDetail"></delete-module>
                                        <delete-module class="deleteModule" :list.sync="partyActItem.otherActList"  :index="2" :isShowModifyBtn="true" titleTxt="其他" @refreshData="getFrontDetail"></delete-module>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="审批过程" name="Tab4">
                        <div v-if="approveFlag === 'currentApprove'">
                            <approveItem
                                    :itemId="contractId"
                                    :approveType="approveType"
                                    :subapproveType="subapproveType"
                                    @finishApprove="reset()"
                            >
                            </approveItem>
                        </div>
                        <div v-else>
                            <approveLine
                                    :itemId="contractId"
                                    :approveType="approveType"
                            ></approveLine>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </el-main>
            <el-footer class="containerBox">
                <div class="btnMid">
                    <el-button type="info" @click="reset()">关 闭</el-button>
                </div>
            </el-footer>
        </el-container>

    </div>
</template>

<script>
    import deleteModule from "../delete-module";
    import {queryApproveProcessService, queryMiddleDetailService} from "../../../services/engineering";

    import approveLine from "@/page/approveComponents/ApproveHistoryLine"; //历史审批流程
    import approveItem from "@/page/approveComponents/ApproveItem";
    import {goBackApprove} from '@/page/approveComponents/approve';

    export default {
        name: "infoDetails",
        data(){
            return {
                activeName: 'Tab1',

                middleId: '',
                dataForm: {},
                approveList: [], // 审批流列表
                engineerList: null, //详情列表
                index: 1, // 1 列表  2审批列表

                approveFlag: '', //审批状态
                approveType: "PROJECT_MIDDLE", //审批类型
                subapproveType: '',
                contractId: 0,
            }
        },
        components:{
            deleteModule,
            approveLine, //审批历史流程
            approveItem, //审批
        },
        methods:{
            onActive(menuCode) {
                this.middleId = this.tabRouteParam.id
                this.index = this.tabRouteParam.index
                this.getFrontDetail()
                this.queryApproveProcess()

                this.approveFlag = this.tabRouteParam
                    ? this.tabRouteParam.approveFlag
                    : "";
                this.contractId = Number(this.tabRouteParam.id);
            },
            // 获取详情信息
            getFrontDetail(){
                let paramsData = {
                    middleId: this.middleId
                }
                queryMiddleDetailService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.engineerList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            // 获取审批列表
            queryApproveProcess(){
                let paramsData = {
                    itemId: this.middleId,
                    approveClass: 'PROJECT_MIDDLE'
                }
                queryApproveProcessService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.approveList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            reset(){
                if(this.approveFlag){
                    goBackApprove(this.approveFlag,'inTheInfoDetails')
                }else{
                    this.bus.$emit("tabClose", "inTheInfoDetails");
                    this.bus.$emit("navMenuChange", {
                        routeId: "inTheIndex"
                    });
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .engineering {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
      .tabWrap {
        height: calc(100% - 60px);

        /deep/ .el-tabs--top {
          height: 100%;
          overflow: hidden;

          .el-tabs__content {
            height: calc(100% - 140px);
            padding: 0 20px 20px;
            overflow: auto;

            .el-form-item {
              width: 100%;
            }

            .el-checkbox {
              line-height: 40px;
            }

            .el-textarea {
              min-width: 0px !important;
            }
            .el-cascader {
              width: 100%;
            }

            .el-form-item__content {
              width: calc(100% - 150px);

              .el-input {
                width: 100%;
              }
            }
          }
        }
      }
    }
    .dataFormBox{
        margin:30px 20px;
    }
    /deep/.el-tabs__item{
        padding: 0 20px !important;
    }
    .containerBox {
        width: 100%;
        height: 36px !important;
        position: fixed;
        bottom: 44px;
        left: 0;
        text-align: start;
    }
    .btnMid {
        position: relative;
        left: 27%;
        bottom: 0px;
        display: flex;
    }
    /deep/.ApproveItem .bottomBtn{
        bottom: 44px;
        z-index: 10;
    }
</style>
